import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
	icons: {
    	iconfont: 'fa',
  	},
  	theme: {
		themes: {
			light: {
				primary: '#1B1045', // azul fuerte
				accent: '#3E037E', // morado
				secondary: '#002A76', // azul no tan fuerte
				info: '#9CA59A',
				bar: colors.grey.lighten5,
				warning: colors.pink.darken1,
				error: colors.red.accent4,
				success: colors.green.base,
				cancel: colors.grey.darken1,
				tip: colors.red.darken1,

				declat: '#1D6BAF',
				sermas: '#8C459B',
				dharma: '#00E000'
			}
		}
	} 
})


